import septeoLogo from '../../../assets/images/icons/septeo-logo.png';
import immofacileLogo from '../../../assets/images/icons/immofacile-logo.png';
import leedpulseLogo from '../../../assets/images/logo/logo-minimalist.png';
import leedflowLogo from '../../../assets/images/logo/logo-leedflow-minimalist.png';

interface UserPartnerLogoProps {
  partnerSystem: string;
}

const LOGOS: Record<string, { src: string; alt: string; title: string }> = {
  septeo: { src: septeoLogo, alt: 'Septeo logo', title: 'Logo Septeo' },
  immofacile: {
    src: immofacileLogo,
    alt: 'Immo Facile logo',
    title: 'Logo Immo Facile',
  },
  leedpulse: {
    src: leedpulseLogo,
    alt: 'Leedpulse logo',
    title: 'Logo Leedpulse',
  },
  backoffice_paiement_link: {
    src: leedflowLogo,
    alt: 'Leedflow logo',
    title: 'Logo Leedflow (interne)',
  },
  default: {
    src: leedflowLogo,
    alt: 'Leedflow logo',
    title: 'Logo Leedflow (interne)',
  },
};

const imgStyle = { height: '16px', width: '16px', borderRadius: '15px', marginRight: '.5rem' };

const UserPartnerLogo: React.FC<UserPartnerLogoProps> = ({ partnerSystem }) => {
  const logo = LOGOS[partnerSystem ?? 'default'] ?? LOGOS.default;

  return <img src={logo.src} style={imgStyle} alt={logo.alt} title={logo.title} />;
};

export default UserPartnerLogo;
